export default class AbstractChart 
{
	
	constructor(params) 
	{
		// if (!params instanceof AbstractChartParams) {
		// 	return;
		// }
		this.chart = null;
		
		this.params = params;
	}


	createDataTable(rows, cols) 
	{
		const dataTable = new google.visualization.DataTable();
		
		const bools = new Array();

	    for (let i=0; i<cols.length; i++) {
	    	let type  = cols[i][0];
	    	let label = cols[i][1];
	    	if (type === 'boolean') {
	    		bools.push(i);
	    	}
	    	dataTable.addColumn(type, label);
	    }
	    if (bools.length) {
	    	rows.map((row) => {
	  			for(let j=0; j<bools.length; j++) {
	  				let indx = bools[j];
	  				row[indx] = row[indx] === 1;
	  			}
	    		return row;
	    	});
	    }

	    dataTable.addRows(rows);	

		return dataTable;
	}


	draw() 
	{
		this.params.checkForErrors();

		if (this.params.hasErrors()) {

			return false;
		
		}
		
		const data = this.createDataTable(this.params.rows, this.params.cols);

		const visualization = this.createVisualization();
		
		visualization.draw(data, this.params.chart_options);
	}

}